import React from 'react';
import StatusItem from '../engine/FormBuilderStatusItemEngine';
import Button from '../Button';
import useTranslations from '../../hooks/useTranslations';

import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import styled from 'styled-components/macro';

export const Container = styled.div`
  background: #fff;
  width: 1060px;
  height: 100%;
  margin: 20px auto 0;
  padding: 0.8em;
`;

const BelowList = styled.div`
  // text-align: left;
  padding: 0.8em 0;
`;

const FormBuilderStatusesView = props => {
  const t = useTranslations();

  return (
    <Container>
      <DragDropContext onDragEnd={props.onDragEnd}>
        <Droppable droppableId="droppable">
          {provided => (
            <>
              <div ref={provided.innerRef} {...provided.droppableProps}>
                {props.data.map(status => (
                  <StatusItem
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    key={status.id}
                    {...status}
                    updateName={name =>
                      props.dispatch({
                        type: 'update',
                        index: status.position,
                        payload: { statusName: name }
                      })
                    }
                    updateLocked4EndUsers={locked =>
                      props.dispatch({
                        type: 'update',
                        index: status.position,
                        payload: { isLocked4EndUsers: locked }
                      })
                    }
                    onDelete={() =>
                      props.dispatch({
                        type: 'delete',
                        index: status.position
                      })
                    }
                  />
                ))}
              </div>
              {provided.placeholder}
            </>
          )}
        </Droppable>
      </DragDropContext>
      <BelowList>
        <Button
          startIcon={<AddCircleOutlineIcon />}
          variant="text"
          onClick={props.addNewStatus}
        >
          {t('statuses.add')}
        </Button>
      </BelowList>
    </Container>
  );
};

export default FormBuilderStatusesView;
